import Vue from 'vue';
import UserClass from '@/Classes/BaseInformation/UserClass';
export default {
  data() {
    return {
      tab: 1,
      profileClass: 'text-index text-style active-tab',
      accessClass: 'text-index text-style',
      detailClass: 'text-index text-style',
      informationItem: [],
      userImage: '',
      hasImg: false,
      img: null,
      confirmType: '',
      disabelConfirm: false,
      userProfileInformation: null,
      //password
      currentPasswordClass: 'password',
      currentPasswordIcon: 'mdi-eye',
      newPasswordClass: 'password',
      newPasswordIcon: 'mdi-eye',
      newPasswordRepeatClass: 'password',
      newPasswordRepeatIcon: 'mdi-eye',
      currentUserChangePasswordModal: false,
      currentPassword: '',
      newPassword: '',
      newPasswordRepeat: '',
      //edit
      editCurrentUserModal: false,
      tempCurrentUserDate: '',
      showCurrentUserDate: false,
      userProfile: new UserClass.Profile('', null, '', '', ''),
      //attempt
      userLoginInfo: [],
      attemptInfo: [],
    };
  },
  methods: {
    changeTab: function (type) {
      if (type == 1) {
        this.profileClass = 'text-index text-style active-tab';
        this.accessClass = 'text-index text-style';
        this.tab = 1;
        //this.getMissionPhoneReportFunction(this.mainId);
      } else if (type == 2) {
        this.accessClass = 'text-index text-style active-tab';
        this.profileClass = 'text-index text-style';
        this.tab = 2;
        this.getUserCurrentAttemptForProfile();
      }
    },
    makeDataReady: function (data) {
      this.userProfileInformation = data;
      this.userProfile.phoneNumber = data.phoneNumber;
      this.userProfile.emailAddress = data.emailAddress;
      this.userProfile.address = data.address;
      this.userProfile.birthDate = data.birthDate;
      if (data.img) {
        this.hasImg = true;
        this.userImage = data.img;
      }
      this.informationItem = [];
      let birthDate = '-';
      if (data.birthDate) {
        birthDate = Vue.moment(data.birthDate).format('jYYYY/jM/jD');
      }
      this.informationItem.push(
        {
          text: data.firstName ? data.firstName : '-',
          cols: 6,
          icon: 'mdi-account',
          title: 'نام:',
          id: 1,
          size: 4,
        },
        {
          text: data.lastName ? data.lastName : '-',
          cols: 6,
          icon: 'mdi-account',
          title: 'نام خانوادگی:',
          id: 2,
          size: 4,
        },
        {
          text: data.nationalCode ? data.nationalCode : '-',
          cols: 6,
          icon: 'mdi-card-account-details',
          title: 'کدملی:',
          id: 3,
          size: 4,
        },
        {
          text: birthDate,
          cols: 6,
          icon: 'mdi-calendar-range',
          title: 'تاریخ تولد:',
          id: 4,
          size: 4,
        },
        {
          text: data.phoneNumber ? data.phoneNumber : '-',
          cols: 6,
          icon: 'mdi-phone mdi-flip-h',
          title: 'شماره همراه:',
          id: 5,
          size: 4,
        },
        {
          text: data.emailAddress ? data.emailAddress : '-',
          cols: 6,
          icon: 'mdi-email',
          title: 'ایمیل:',
          id: 6,
          size: 4,
        },
        {
          text: data.address ? data.address : '-',
          cols: 12,
          icon: 'mdi-map-marker',
          title: 'آدرس:',
          id: 7,
          size: 12,
        },
      );
    },
    showConfirmDialogFunction: function () {
      if (this.confirmType == 'password') {
        this.$refs.confirm.title = 'تغییر کلمه عبور';
        this.$refs.confirm.text = 'از تغییر کلمه عبور اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confirmType == 'edit') {
        this.$refs.confirm.title = 'ویرایش اطلاعات';
        this.$refs.confirm.text = 'از ویرایش اطلاعات اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confirmType == 'password') {
        this.disabelConfirm = true;
        this.changeCurrentUserPasswordFunction();
      } else if (this.confirmType == 'edit') {
        this.disabelConfirm = true;
        this.editCurrentUserFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confirmType == 'password') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confirmType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //change password
    showEditPasswordModal: function () {
      this.confirmType = 'password';
      this.currentUserChangePasswordModal = true;
    },
    showCurrentPassword: function () {
      if (this.currentPasswordIcon == 'mdi-eye') {
        this.currentPasswordIcon = 'mdi-eye-off';
        this.currentPasswordClass = '';
      } else if (this.currentPasswordIcon == 'mdi-eye-off') {
        this.currentPasswordIcon = 'mdi-eye';
        this.currentPasswordClass = 'password';
      }
    },
    showNewPassword: function () {
      if (this.newPasswordIcon == 'mdi-eye') {
        this.newPasswordIcon = 'mdi-eye-off';
        this.newPasswordClass = '';
      } else if (this.newPasswordIcon == 'mdi-eye-off') {
        this.newPasswordIcon = 'mdi-eye';
        this.newPasswordClass = 'password';
      }
    },
    showNewPasswordRepeat: function () {
      if (this.newPasswordRepeatIcon == 'mdi-eye') {
        this.newPasswordRepeatIcon = 'mdi-eye-off';
        this.newPasswordRepeatClass = '';
      } else if (this.newPasswordRepeatIcon == 'mdi-eye-off') {
        this.newPasswordRepeatIcon = 'mdi-eye';
        this.newPasswordRepeatClass = 'password';
      }
    },
    cancelChangePassword: function () {
      this.currentUserChangePasswordModal = false;
      this.currentPasswordClass = 'password';
      this.currentPasswordIcon = 'mdi-eye';
      this.newPasswordClass = 'password';
      this.newPasswordIcon = 'mdi-eye';
      this.newPasswordRepeatClass = 'password';
      this.newPasswordRepeatIcon = 'mdi-eye';
    },
    //edit
    showEditCurrentUserModal: function () {
      this.confirmType = 'edit';
      this.editCurrentUserModal = true;
      this.currentUserDateChange();
    },
    currentUserDateChange: function () {
      if (this.userProfile.birthDate) {
        this.tempCurrentUserDate = Vue.moment(this.userProfile.birthDate).format('jYYYY-jMM-jDD');
      }
    },
    cancelEditCurrentUser: function () {
      this.editCurrentUserModal = false;
      this.userProfile.phoneNumber = this.userProfileInformation.phoneNumber;
      this.userProfile.emailAddress = this.userProfileInformation.emailAddress;
      this.userProfile.address = this.userProfileInformation.address;
      this.userProfile.birthDate = this.userProfileInformation.birthDate;
      this.tempCurrentUserDate = '';
    },
    //attempt
    makeReadyAttemptData: function (data) {
      this.userLoginInfo = [];
      this.attemptInfo = [];
      for (let i = 0; i < data.userLoginLogoutAttempts.length; i++) {
        let date = '';
        let successText = '';
        if (data.userLoginLogoutAttempts[i].isSuccessful == true) {
          successText = 'موفق';
        } else if (data.userLoginLogoutAttempts[i].isSuccessful == false) {
          successText = 'ناموفق';
        }
        if (data.userLoginLogoutAttempts[i].attemptDate) {
          date = Vue.moment(data.userLoginLogoutAttempts[i].attemptDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
        this.userLoginInfo.push({
          date: date,
          ip: data.userLoginLogoutAttempts[i].ipAddress
            ? data.userLoginLogoutAttempts[i].ipAddress
            : '-',
          successText: successText,
        });
      }
      let lastLogInAttemptDate = '-';
      if (data.lastLogInAttemptDate) {
        lastLogInAttemptDate = Vue.moment(data.lastLogInAttemptDate).format(
          'HH:mm:ss jYYYY-jMM-jDD',
        );
      }
      this.attemptInfo.push(
        {
          title: 'آی پی جاری',
          value: data.lastLogInIp ? data.lastLogInIp : '-',
          icon: 'mdi-ip mdi-18px',
          size: 3,
        },
        {
          title: 'تعداد تلاش ناموفق',
          value: data.lastFailedLogInCount ? data.lastFailedLogInCount : 0,
          icon: 'mdi-counter mdi-18px',
          size: 3,
        },
        {
          title: 'آخرین تلاش ناموفق',
          value: lastLogInAttemptDate,
          icon: 'mdi-calendar-blank-outline mdi-18px',
          size: 3,
        },
        {
          title: 'آی پی تلاش ناموفق',
          value: data.lastLogInAttemptIp ? data.lastLogInAttemptIp : '-',
          icon: 'mdi-ip mdi-18px',
          size: 3,
        },
      );
    },
  },
};
